import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {BaseConnectionModel, ItemGroupsQuery, ItemInItemGroupModel, ItemsQuery, ManufacturingItemGroupModel, ManufacturingItemModel} from "web-shared";
import {ManufacturingItemGroupEditModalComponent} from "../manufactured-item-groups/manufacturing-item-group-edit-modal/manufacturing-item-group-edit-modal.component";
import {BaseComponent, BaseIdCodeQuery, ClassificatorValuesQuery, LeModalService} from "common-shared";
import {ManufacturingItemEditModalComponent} from "../manufacturing-item/manufacturing-item-edit-modal/manufacturing-item-edit-modal.component";
import {SortEvent} from "primeng/api";
import {takeUntil} from "rxjs/operators";
import {Observable} from "rxjs";

@Component({
  selector: 'app-datasets-edit-card',
  templateUrl: './datasets-edit-card.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatasetsEditCardComponent extends BaseComponent {
  @Input() container: ManufacturingItemModel | ManufacturingItemGroupModel;
  @Input() readonly = false;
  @Input() isItem = false;
  @Input() cssClass: string;
  @Output() changed = new EventEmitter<boolean>();
  rowsPerPage = 10;
  firstRow = 0;

  constructor(private modalService: LeModalService, public itemGroupsQuery: ItemGroupsQuery, public itemsQuery: ItemsQuery, public classificatorValuesQuery: ClassificatorValuesQuery) {
    super();
  }

  add() {
    const newDataset = new ItemInItemGroupModel({
      ItemId: this.isItem ? this.container.Id : null,
      ItemGroupId: this.isItem ? null : this.container.Id,
      $isNew: true
    });
    this.container.ItemInItemGroups = [...this.container.ItemInItemGroups, newDataset];
    this.firstRow = BaseConnectionModel.getFirstRowNrOfLastPage(this.container.ItemInItemGroups.length, this.rowsPerPage);
    this.changed.emit();
  }

  remove(dataset: ItemInItemGroupModel) {
    this.container.ItemInItemGroups = [...this.container.ItemInItemGroups.filter(value => value !== dataset)];
    this.changed.emit();
  }

  open(dataset: ItemInItemGroupModel) {
    if (this.isItem) {
      this.modalService.show(ManufacturingItemGroupEditModalComponent, {initialState: {entityId: dataset.ItemGroupId}, class: 'modal-xl'});
    } else {
      this.modalService.show(ManufacturingItemEditModalComponent, {initialState: {entityId: dataset.ItemId}, class: 'modal-xl'});
    }
  }

  customSort(event: SortEvent) {
    if (event.field === 'ItemGroupId') {
      this.sortByCustomColumn('ItemGroup', this.itemGroupsQuery.getAll$, event);
    } else if (event.field === 'ItemId') {
      this.sortByCustomColumn('Item', this.itemsQuery.getAll$, event);
    } else if (event.field === 'TypeClv') {
      this.sortByCustomColumn('Type', this.classificatorValuesQuery.getAll$, event);
    } else {
      BaseConnectionModel.sort(event);
    }
  }

  private sortByCustomColumn(helperColumn: string, entities$: Observable<BaseIdCodeQuery[]>, event: SortEvent) {
    entities$.pipe(takeUntil(this.componentDestroyed)).subscribe(entities => {
      event.data.map(data => {
        data[helperColumn] = entities.find(clv => clv.Id === data[event.field])?.DisplayName;
      });
      event.field = helperColumn;
      BaseConnectionModel.sort(event);
    });
  }

  setDateRange(dateRange: { From: Date, To: Date }, entity: BaseConnectionModel) {
    if (entity.FromDate !== dateRange?.From || entity.ToDate !== dateRange?.To) {
      this.changed.emit();
    }
    entity.FromDate = dateRange ? dateRange.From : null;
    entity.ToDate = dateRange ? dateRange.To : null;
  }
}
